document.addEventListener('DOMContentLoaded', function() {
  var popup = document.getElementById('custom-measurement-popup');
  var modalContent = document.querySelector('.measurement-modal-content');
  var closeBtn = document.querySelector('.measurement-modal-close');
  var form = document.getElementById('custom-measurement-form');
  var productForm = document.querySelector('.product-form form');
  var customKeyword = "Custom"; // Change to your custom option name if needed

  // Show popup when custom variant is selected (dropdown or swatch)
  document.body.addEventListener('change', function(e) {
    if (e.target.matches('select[name="id"]')) {
      var selectedOption = e.target.options[e.target.selectedIndex];
      if (selectedOption.text.includes(customKeyword)) {
        popup.style.display = 'flex';
      } else {
        popup.style.display = 'none';
      }
    }
  });
  document.body.addEventListener('click', function(e) {
    if (e.target.matches('label.block-swatch__item')) {
      if (e.target.textContent.trim().includes(customKeyword)) {
        popup.style.display = 'flex';
      } else {
        popup.style.display = 'none';
      }
    }
  });

  // Close on cross icon
  closeBtn.addEventListener('click', function() {
    popup.style.display = 'none';
  });

  // Close when clicking outside modal content
  popup.addEventListener('click', function(e) {
    if (!modalContent.contains(e.target)) {
      popup.style.display = 'none';
    }
  });

  // On Save, add all fields as hidden inputs to product form
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      Array.from(productForm.querySelectorAll('input[name^="properties["]')).forEach(function(input) {
        input.remove();
      });
      Array.from(form.elements).forEach(function(field) {
        if (
          field.name &&
          (field.type === 'number' || field.tagName === 'SELECT' || field.type === 'text')
        ) {
          var input = document.createElement('input');
          input.type = 'hidden';
          if (field.name.startsWith('properties[')) {
            input.name = field.name;
          } else {
            input.name = 'properties[' + field.name + ']';
          }
          input.value = field.value;
          productForm.appendChild(input);
        }
      });
      popup.style.display = 'none';
    });
  }
});